import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { RootState } from "../store"; // Replace with your actual store path
import { LoginModal } from "../components";

interface Props {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: Props) {
  const user = useSelector((state: RootState) => state.user);
  const location = useLocation();
  if (!user?.user?.userId) {
    return (
      <Navigate to="/login" replace state={{ prevLoc: location?.pathname }} />
    );
  }

  return <>{children}</>;
}

// export default function ProtectedRoute({ children }: Props) {
//   const user = useSelector((state: RootState) => state.user);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   useEffect(() => {
//     if (!user?.user?.email) {
//       dispatch(setAuth(true));
//       navigate(-1); // go back to previous page
//     }
//   }, [user, dispatch, navigate]);

//   if (!user?.user?.email) {
//     return null; // Prevent rendering children while redirecting
//   }

//   return <>{children}</>;
// }
